import { takeEvery, call, put } from 'redux-saga/effects';
import * as toastMsg from '../../core/toastMessages';
import { hideDialog } from '../../core/actions';

function* vendingSalesSaga() {
  yield call(toastMsg.vendingSalesUpdated);
}

function* otherIncomeSaga() {
  yield call(toastMsg.otherIncomeUpdated);
}

function* profitAndLossSaga() {
  yield put(hideDialog());
}

function* profitAndLossErrorSaga() {
  yield put(hideDialog());
}

export function* watchExpensesSagas() {
  yield takeEvery('UPDATE_VENDING_SALES_SUCCESS', vendingSalesSaga);
  yield takeEvery('UPDATE_OTHER_INCOME_SUCCESS', otherIncomeSaga);
  yield takeEvery('UPLOAD_PROFIT_AND_LOSS_SUCCESS', profitAndLossSaga);
  yield takeEvery('UPLOAD_PROFIT_AND_LOSS_FAILURE', profitAndLossErrorSaga);
}
